export enum DockerfileMode {
  SOURCE = 'source',
  PATH = 'path',
}
export function isDockerfileMode(mode: string): mode is DockerfileMode {
  return mode === DockerfileMode.SOURCE || mode === DockerfileMode.PATH
}
